export const experiences = [
  {
    id: 0,
    company: "ATMTA Technological Solutions",
    position: "Software Engineer",
    duration: "Nov 2025 – Jun 2026",
    startDate: "2025-11",
    endDate: "2026-06",
    current: false,
    type: "Remote",
    description: "Developed and scaled two high-traffic Flutter applications (Musafer & Masar) using Clean Architecture and BLoC state management. Designed automated CI/CD pipelines, configured secure VPS deployments, and integrated enterprise hardware features. Managed the company's corporate website creation using AI-driven workflows and participated in client acquisition.",
    responsibilities: [
      "Developed and scaled Musafer (passenger booking) and Masar (transport ERP with 23+ modules) using Clean Architecture, BLoC, and optimized RESTful API integrations via Dio",
      "Designed and implemented GitHub Actions CI/CD workflows for automated code analysis (Linting/Static Analysis), production Android package compilation (signed APK/AAB via GitHub Secrets), and web deployments",
      "Configured secure automated web delivery to Linux VPS servers using SSH and rsync, managing Next.js and web services gracefully using PM2 process manager",
      "Integrated specialized hardware features: Bluetooth thermal receipt printing, QR code scanning, and Firebase Cloud Messaging (FCM) real-time push notifications",
      "Managed and directed the complete design and copy strategy for the company's official corporate website using AI-driven workflows",
      "Participated in client acquisition by pitching the transport booking platform directly to regional transport operators, driving product adoption",
      "Built multi-role access control (Super Admin, Supervisor, Booking Agent, Driver, Inspector) with comprehensive permission systems",
      "Implemented bilingual (Arabic/English) localization with full RTL support across all products"
    ],
    technologies: ["Flutter", "Dart", "BLoC", "Dio", "GoRouter", "Firebase FCM", "GitHub Actions", "CI/CD", "Linux VPS", "SSH/rsync", "PM2", "QR Scanner", "Bluetooth Printer"]
  },
  {
    id: 1,
    company: "YES for Online Services",
    position: "Flutter Developer",
    duration: "Nov 2023 – Oct 2024",
    startDate: "2023-11",
    endDate: "2024-10",
    current: false,
    type: "Hybrid",
    description: "Developed cross-platform Flutter applications for iOS, Android, and Windows, including the Team Management app that unified employee operations across platforms and the iDBOOK marketplace applications released on Google Play.",
    responsibilities: [
      "Developed cross-platform Flutter applications for iOS, Android, and Windows, including the Team Management app that unified employee operations across platforms",
      "Built the iDBOOK and iDBOOK Agent mobile apps with advanced search, real-time updates, QR code-based payment activation, and role-based functionality",
      "Developed the Team Management desktop & mobile app, improving team productivity by 30% across 20+ employees with real-time chat (Socket.IO), task tracking, and admin dashboards",
      "Collaborated with cross-functional teams to ensure consistent UI/UX performance and code quality through rigorous testing and iteration",
      "Implemented clean architecture principles and scalable state management for long-term maintainability"
    ],
    technologies: ["Flutter", "Dart", "Firebase", "GetX", "Provider", "Socket.IO", "Node.js", "Google Maps", "QR Code", "SQLite", "Hive"]
  },
  {
    id: 2,
    company: "Darrebni Company",
    position: "Flutter Trainee",
    duration: "Mar 2023 – Nov 2023",
    startDate: "2023-03",
    endDate: "2023-11",
    current: false,
    type: "Onsite",
    description: "Contributed to multiple collaborative mobile projects, enhancing teamwork, agile development, and communication skills. Built the Darrebni National exam preparation platform as a final training project.",
    responsibilities: [
      "Contributed to multiple collaborative mobile projects, enhancing teamwork, agile development, and communication skills",
      "Actively participated in project planning, code reviews, and problem-solving sessions, leading to measurable improvements in delivery speed and efficiency",
      "Applied Flutter Clean Architecture and state management techniques to build scalable training applications",
      "Developed Darrebni National platform as a final project — a unified study resource for Syrian National Unified Exam preparation",
      "Collaborated with another trainee to design, develop, and refine the platform, focusing on clean architecture, responsive UI, and smooth navigation"
    ],
    technologies: ["Flutter", "Dart", "Firebase", "Clean Architecture", "GetX", "Hive"]
  },
  {
    id: 3,
    company: "Japan Syria Friendship Association",
    position: "Flutter Trainee",
    duration: "Oct 2022 – Nov 2022",
    startDate: "2022-10",
    endDate: "2022-11",
    current: false,
    type: "Onsite",
    description: "Completed intensive Flutter mobile app development training, mastering advanced UI, animations, and state management under mentorship.",
    responsibilities: [
      "Completed intensive Flutter mobile app development training, mastering advanced UI, animations, and state management",
      "Collaborated closely with mentors to refine code performance, structure, and best practices in production-level applications",
      "Built practical Flutter projects applying learned concepts in real-world scenarios"
    ],
    technologies: ["Flutter", "Dart", "Animations", "State Management", "UI/UX"]
  },
  {
    id: 4,
    company: "Freelance",
    position: "Flutter Developer",
    duration: "2022 – Present",
    startDate: "2022-01",
    endDate: null,
    current: true,
    type: "Remote",
    description: "Delivering cross-platform Flutter applications for various clients with a 90% success rate, implementing innovative user interfaces, optimized performance, and customized solutions.",
    responsibilities: [
      "Implemented innovative user interfaces and optimized application performance based on client requirements with a success rate of 90%",
      "Provided customized solutions and achieved outstanding results in collaboration with clients",
      "Handle full project lifecycle from requirements analysis and architecture design to development, testing, and deployment",
      "Built applications spanning e-commerce, food ordering, health tracking, and community platforms"
    ],
    technologies: ["Flutter", "Dart", "Firebase", "Node.js", "BLoC", "GetX", "Clean Architecture", "Various APIs"]
  }
];